import { TemplateInfo } from '@modules/BillOfMaterials/Components/TemplateInfo/TemplateInfo';
import { BREADCRUMBS_LABELS } from '@configs/BreadcrumbsLabels';
import Breadcrumbs from '@shared/Widgets/Navigation/Breadcrumbs/Breadcrumbs';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';

const TemplateInfoPage: React.FC = () => {
    const { tempId } = useParams();
    const [isDesktop, _isTablet, _isMobile] = useMediaType();

    const {
        fetchTemplateHtmlContent,
        removeTemplateDescription,
        isTemplateDataLoading,
        currentTemplate,
    } = useTemplatesViewModel();

    useEffect(() => {
        fetchTemplateHtmlContent(Number(tempId));

        return () => {
            removeTemplateDescription();
        };
    }, []);

    if (isTemplateDataLoading) return <BasicLoader />;

    return (
        <>
            {isDesktop && currentTemplate && (
                <Breadcrumbs
                    items={BREADCRUMBS_LABELS.TEMPLATE_INFO(
                        currentTemplate.title
                    )}
                />
            )}
            <TemplateInfo />
        </>
    );
};

export default TemplateInfoPage;
